export const DataUsesSection = () => (
  <section>
    <h2>2. Data Uses</h2>

    <p>
      Volca processes Customer Data, and the personal data contained in it,
      strictly on our customer's behalf, in accordance with their reasonable
      instructions and as further stipulated in our Data Processing Addendum and
      other commercial agreements with such customer.
    </p>

    <p>
      We use other types of Personal Data (Volca User Data and Volca Website,
      CRM & Prospect Data) as necessary for the performance of our Services; to
      comply with our legal and contractual obligations; and to support our
      legitimate interests in maintaining and improving our Services, e.g. in
      understanding how our Services are used and how our campaigns are
      performing, and gaining insights which help us dedicate our resources and
      efforts more efficiently; in marketing, advertising and selling our
      Services; providing customer service and technical support; and protecting
      and securing our customers, users, visitors, prospects, ourselves and our
      Services.
    </p>

    <p>
      If you reside or are using the Services in a territory governed by privacy
      laws under which "consent" is the only or most appropriate legal basis for
      the processing of Personal Data as described herein (in general, or
      specifically with respect to the types of Personal Data you expect or
      elect to process or have processed by or via the Services, e.g. 'special
      categories' under the GDPR), your acceptance of our Privacy Policy will be
      deemed as your consent to the processing of your Personal Data for all
      purposes detailed in this Policy. If you wish to revoke such consent,
      please contact us at{" "}
      <a href="mailto:support@volca.ai">support@volca.ai</a>.
    </p>

    <p>
      We do not sell your personal information for the intents and purposes of
      the California Consumer Privacy Act (CCPA).
    </p>

    <p>
      Specifically, we use Volca User Data and Volca Website, CRM & Prospect
      Data for the following purposes:
    </p>

    <ul>
      <li>To facilitate, operate, and provide our Services;</li>
      <li>To train our customer and user-facing staff;</li>
      <li>
        To authenticate the identity of our users, and to allow them access to
        our Services;
      </li>
      <li>To provide our customers and users with assistance and support;</li>
      <li>
        To gain a better understanding on how individuals use and interact with
        our Sites and Services, and how we could improve their and others' user
        experience, and continue improving our products, offerings and the
        overall performance of our Services;
      </li>
      <li>
        To facilitate and optimize our marketing campaigns, ad management and
        sales operations, and to manage and deliver advertisements for our
        products and services more effectively, including on other websites and
        applications. Such activities allow us to highlight the benefits of
        using our Services, and thereby increase your engagement and overall
        satisfaction with our Services. This includes contextual, behavioral and
        interests-based advertising based on your activity, preferences or other
        data available to us or to our business partners;
      </li>
      <li>
        To contact our customers, users and prospects with general or
        personalized service-related messages, as well as promotional messages
        that may be of specific interest to them (as further described in
        Section ‎‎7 below);
      </li>
      <li>
        To facilitate, sponsor and offer certain events, contests and
        promotions;
      </li>
      <li>
        To support and enhance our data security measures, including for the
        purposes of preventing and mitigating the risks of fraud, error or any
        illegal or prohibited activity;
      </li>
      <li>
        To create aggregated statistical data, inferred non-personal data, or
        anonymized or pseudonymized data (rendered non-personal and
        non-identifiable), which we or our business partners may use to provide
        and improve our respective services, or for any other purpose; and
      </li>
      <li>To comply with applicable laws and regulations.</li>
    </ul>
  </section>
);
